import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  inventorySectionHeader: {
    fontWeight: 700
  }
})

export default useStyles
